export const leadOwnerOptions = [
  { value: 1, label: "پلنیوم" },
  { value: 2, label: "رابین" },
  { value: 0, label: "بدون مالک لید" },
];

export const getLeadOwnerValues = (value) => String(value ?? "")
  .split(",")
  .map((owner) => owner.trim())
  .filter(Boolean)
  .map(Number);

export const getLeadOwnerLabel = (value) => {
  return getLeadOwnerValues(value)
    .map((owner) => leadOwnerOptions.find((option) => option.value === owner)?.label)
    .filter(Boolean)
    .join("، ") || "—";
};
